import { OfflineDatabaseModule } from './../database/offline-database.module';
import { SharedModule } from './../shared/shared.module';
import { FooterComponent } from './../shared/components/footer/footer.component';
import { ActivatedRoute } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthRoutingModule } from './auth-routing.module';
import { LibsModule } from './../libs/libs.module';

import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { HttpClientModule } from '@angular/common/http';


@NgModule({
  declarations: [
    LoginComponent,
    RegisterComponent,
    ResetPasswordComponent,
  ],
    imports: [
        CommonModule,
        AuthRoutingModule,
        FormsModule,
        LibsModule,
        HttpClientModule,
        ReactiveFormsModule,
        SharedModule,
        OfflineDatabaseModule
    ],
  exports: [
    LoginComponent,
    RegisterComponent,
    ResetPasswordComponent,
  ],
})
export class AuthModule { }
